export default {
  getList: state => state.list,
  getDetail: state => state.detail,
  getPreViewImage: state => state.preViewImage,
  getSelectedImage: state => state.selectedImage,
  getHasItem: state => state.hasItem,
  getGalleryItemList: state => state.galleryItemList
};
